<template>
  <v-container fluid  v-if="!!value" class="mr-6">
    <v-row class="flex-nowrap">
    <v-btn-toggle
        dense
        v-model="statusGroup"
        multiple
        @change="onChange()"
    >
      <v-tooltip bottom v-for="item of value">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" small elevation="2" :color="item.color" dense>
            <v-icon :color="item.icon_color">{{item.icon}}</v-icon>
            {{item.label}}
            <small class="mt-1">{{ getByFilterCount(item) }}</small>
          </v-btn>
        </template>
        <span v-if="!!item.text">{{item.text}}</span>
        <span v-else>{{item.label}}</span>
      </v-tooltip>
    </v-btn-toggle>
    <v-btn
        v-if="statusGroup.length > 0 && clearable"
        small
        icon
        @click="statusGroup=[]; onChange()"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'BaseFilterGroup',
  inheritAttrs: false,
  props: {
    value: {default: null},
    itemList: {default: []},
    rowFilterNames: {default: null},
    clearable: {default: true},
  },

  components: {},

  computed: {},

  methods: {
    getByFilterCount(filterItem) {
      return this.itemList.filter(row => !!row[this.rowFilterNames] &&
          row.deleted === false &&
          row[this.rowFilterNames].includes(filterItem.name)).length
    },
    onChange() {
      let activeFilterNames = []
      this.statusGroup.forEach(row => activeFilterNames.push(this.value[row].name))
      this.$emit('update:filter-names', activeFilterNames)
      // console.log('update:filter-names', this.statusGroup, this.value, activeFilterNames)
    },
  },

  async mounted() {
  },

  data() {
    return {
      statusGroup: [],
    }
  }
}
</script>

